import React, { useEffect } from "react";
import {
  enums,
  createInstance,
  OptimizelyProvider as SDKProvider,
} from "@optimizely/react-sdk";
import useDeviceInfo from "@hooks/useDeviceInfo";
import { getParameterByName } from "@helpers/QueryString";
import { onDecision } from "@helpers/ContentSquare";

const optimizely = createInstance({
  sdkKey: "WNF3wQLPoGLithQPJrmvr",
});

// Add ContentSquare tracking for variations
optimizely.notificationCenter.addNotificationListener(
  enums.NOTIFICATION_TYPES.ACTIVATE,
  onDecision
);

const OptimizelyProvider = ({ children }) => {
  const { cookieConsent, analyticsId } = useDeviceInfo();

  useEffect(() => {
    const forcedVariationQueryParams = getParameterByName("dyh-opt-variation");

    const [experimentKey, forcedVariationKey] = forcedVariationQueryParams
      ? forcedVariationQueryParams.split(":")
      : [null, null];

    if (experimentKey && forcedVariationKey) {
      console.log(
        `%cForced Optimizely variation: ${experimentKey}, ${forcedVariationKey}`,
        "color: #fbd911"
      );

      if (optimizely.setForcedVariation) {
        optimizely.setForcedVariation(
          experimentKey,
          analyticsId,
          forcedVariationKey
        );
      }
    }
  }, []);

  return cookieConsent ? (
    <SDKProvider
      optimizely={optimizely}
      user={{
        id: analyticsId,
      }}
    >
      {children}
    </SDKProvider>
  ) : (
    <>{children}</>
  );
};

export default OptimizelyProvider;
